import { Injectable } from '@angular/core';
import { RESTServiceBase } from '../../common/service.base';
import { BulletinParticipantDescriptor } from './model/bulletin.participant';
import { List } from '../../common/model/List_T';
import { AppConfig } from '../../configuration/app.config';
import { AuthService } from '../../services/auth.service';
import { View } from '../../common/model/view';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class BulletinParticipantService extends RESTServiceBase {

  constructor(
    authService: AuthService,
    config: AppConfig
  ) {
    super(
      'v1',
      'BulletinParticipantManagement',
      authService,
      config.BMSConfig
    );
  }

  public create(BulletinParticipant: BulletinParticipantDescriptor): Promise<BulletinParticipantDescriptor> {
    return super.post<BulletinParticipantDescriptor>(
      new BulletinParticipantDescriptor({
        id: undefined,
        href: undefined,
        bulletinId: BulletinParticipant.bulletinId,
        profileId: BulletinParticipant.profileId,
        externalCommunicationAllowed: BulletinParticipant.externalCommunicationAllowed,
        modified: BulletinParticipant.modified,
        deleted: BulletinParticipant.deleted
      }));
  }

  public getBulletinParticipants(view?: View): Promise<List<BulletinParticipantDescriptor>> {
    return super.get<List<BulletinParticipantDescriptor>>(undefined, view);
  }

  public delete(id: string): Promise<void> {
    return super.delete(id);
  }

  public update(id: string, BulletinParticipant: BulletinParticipantDescriptor): Promise<BulletinParticipantDescriptor> {
    return super.put<BulletinParticipantDescriptor>(id, BulletinParticipant);
  }

  public getById(id: string): Promise<BulletinParticipantDescriptor> {
    return super.get<BulletinParticipantDescriptor>(id);
  }

  public upload(id: string, files: Set<File>): { [key: string]: Observable<number> } {
    return this.auth.upload(this.buildUrl(id) + '/upload', files);
  }

  public download(id: string): Promise<Blob> {
    return this.auth.download(this.buildUrl(id) + '/download');
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/bulletin.participant/bulletin.participant.service.ts